module.exports = __webpack_public_path__ + "static/img/065_TO8_1629_og.2f14762.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/065_TO8_1629_og.jpg
// module id = wwUM
// module chunks = 0